import { Loader, useGetCreditApplicationById, useSubmissionProgress, VouchedPreparePage } from '@applyonline/shared'
import { ClosedApplicationTile } from '@applyonline/shared/components'
import { scrollToTop } from '@applyonline/shared/utils'
import { ECreditApplicationStatus, EFinancingProgram } from '@if/core/types'
import { useEffect, useLayoutEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import useRequiredDocumentsWithStatus from '../../data/creditapp-hooks'
import useFaqLink from '../../hooks/useFaqLink'
import AgentContactPage from '../CancelApplication/AgentContactPage'
import InitialApprobationForm from '../InitialApprobationPage/InitialApprobationForm'
import CompletedAppPage from './CompletedApp/CompletedAppPage'
import MultipleCreditReportsFound from './components/MultipleCreditReportsFound'
import { canPollCreditApp, computeHighLevelPage, isServerAnalysingCredit } from './credit-hooks'
import HardHitApprovedResultPage from './HardHitApprovedResultPage'
import HardHitUnapprovedResultPage from './HardHitUnapprovedResultPage'
import PrequalificationResultPage from './PrequalResultPage'
const RouteToStatePage = () => {
  const { t } = useTranslation()
  const allParams = useParams()
  const id = allParams.id!
  const [shouldPoll, setShouldPoll] = useState(false)
  const [creditApp, isFetchingCreditApp] = useGetCreditApplicationById(id, EFinancingProgram.B2c, shouldPoll) // if true, poll every 5 secs
  const requiredDocuments = useRequiredDocumentsWithStatus(creditApp?.requiredDocuments, creditApp?.documents)
  const faqHref = useFaqLink()

  const highLevelPage = computeHighLevelPage(creditApp, isFetchingCreditApp)
  const { progress, messageKey } = useSubmissionProgress(creditApp)

  useEffect(() => {
    if (creditApp) {
      const should = isServerAnalysingCredit(creditApp) && canPollCreditApp(creditApp)
      setShouldPoll(should)
    }
  }, [creditApp])

  useLayoutEffect(scrollToTop, [])

  if ((!creditApp && isFetchingCreditApp) || highLevelPage === 'loading' || !creditApp) {
    return <Loader />
  }
  const creditAppStatus = creditApp.status as ECreditApplicationStatus.Completed | ECreditApplicationStatus.Cancelled
  const targetPath = '/'

  return (
    <>
      {highLevelPage === 'analysis-running' && (
        <div>
          <Loader title={t('finalDecision.processing')} description={t(messageKey as 'loader.submitting')} progression={progress} />
        </div>
      )}
      {highLevelPage === 'cancelling' && <AgentContactPage />}
      {highLevelPage === 'vouched' && (
        <VouchedPreparePage
          nextHref={`/creditApplication/${id}/vouchedPage`}
          faqHref={faqHref}
          preApprovedMessage={t('eligibility.preApproved')}
        />
      )}
      {highLevelPage === 'prequal-result' && <PrequalificationResultPage creditApp={creditApp} />}
      {highLevelPage === 'hardhit-result' && <HardHitUnapprovedResultPage creditApp={creditApp} />}
      {highLevelPage === 'first-approval' && <InitialApprobationForm creditApp={creditApp} />}
      {highLevelPage === 'multipleCreditReportsFound' && <MultipleCreditReportsFound creditApp={creditApp} />}
      {highLevelPage === 'approved' && (
        <HardHitApprovedResultPage creditApp={creditApp} requiredDocuments={requiredDocuments} />
      )}
      {highLevelPage === 'funding' && <CompletedAppPage />}
      {highLevelPage === 'closed' && <ClosedApplicationTile status={creditAppStatus} targetPath={targetPath} />}
    </>
  )
}

export default RouteToStatePage
